<template>
  <page-list
    ref="EXTERNAL"
    :list="list"
    :columns="columns"
    :export-data-options="exportDataOptions"
    :dataMapper="listDataMapper" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getCreatedAtFilter } from '@/utils/common/tableFilter'

export default {
  name: 'ReportList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    data: Object,
    getParams: String || Function,
    columns: Array,
    exportDataOptions: Object,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: 'ReportList',
        resource: 'reports',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          created_at: getCreatedAtFilter(),
          // values: {
          //   field: 'values',
          //   label: 'values',
          //   filter: true,
          //   formatter: (val) => {
          //     return `values.contains(${val})`
          //   },
          // },
        },
      }),
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        scope: this.$store.getters.scope,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        details: true,
        filter: [
          `report_setting_id.equals(${this.data.report_setting_id})`,
          `name.equals(${this.data.name})`,
        ],
      }
      return ret
    },
    listDataMapper (data, extraData) {
      for (const k in data) {
        if (data[k].data && data[k].data.values) {
          for (const j in data[k].data.values) {
            data[k].data[j] = data[k].data.values[j]
          }
        }
      }
      return data
    },
  },
}
</script>
